(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7391],{

/***/ 1887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(92310);

/***/ }),

/***/ 74268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useGetCourseOverview; },
/* harmony export */   "a": function() { return /* binding */ queryKeys; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52621);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97478);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99167);




var P = "courseOverview";
var queryKeys = {
    get: function(slug) {
        return [
            P,
            slug
        ];
    }
};
var fetchCourseOverview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api__WEBPACK_IMPORTED_MODULE_1__/* .authFetch */ .SH(_api__WEBPACK_IMPORTED_MODULE_1__/* .courseOverviewUrl */ .bY(slug))
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) {
                        throw Error("Nepodarilo sa nač\xedtať kurz");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchCourseOverview(slug) {
        return _ref.apply(this, arguments);
    };
}();
var useGetCourseOverview = function(slug, enabled) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKeys.get(slug), function() {
        return fetchCourseOverview(slug);
    }, {
        enabled: enabled
    });
};


/***/ }),

/***/ 41777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useGetCourseReviewsOverview; },
/* harmony export */   "a": function() { return /* binding */ queryKeys; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52621);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97478);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99167);




var P = "courseReviewsOverview";
var queryKeys = {
    get: function(courseId) {
        return [
            P,
            courseId.toString()
        ];
    }
};
var fetchCourseReviewsOverview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(courseId) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api__WEBPACK_IMPORTED_MODULE_1__/* .authFetch */ .SH(_api__WEBPACK_IMPORTED_MODULE_1__/* .courseReviewsOverviewUrl */ .tg(courseId))
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) {
                        throw Error("Nepodarilo sa nač\xedtať kurzov\xe9 hodnotenia");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchCourseReviewsOverview(courseId) {
        return _ref.apply(this, arguments);
    };
}();
var useGetCourseReviewsOverview = function(courseId) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKeys.get(courseId), function() {
        return fetchCourseReviewsOverview(courseId);
    });
};


/***/ }),

/***/ 78693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KM": function() { return /* binding */ useGetCourseReviews; },
/* harmony export */   "hp": function() { return /* binding */ useEditCourseReview; },
/* harmony export */   "mw": function() { return /* binding */ useAddCourseReview; },
/* harmony export */   "yE": function() { return /* binding */ useDeleteCourseReview; }
/* harmony export */ });
/* unused harmony export mutationKeys */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52621);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97478);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99167);
/* harmony import */ var _queryClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42425);
/* harmony import */ var _courseReviewOverviews__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41777);
/* harmony import */ var _courses__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44539);
/* harmony import */ var _courseOverview__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74268);








var P = "courseReviews";
var mutationKeys = {
    add: [
        P,
        "add"
    ],
    edit: function(reviewId) {
        return [
            P,
            "edit",
            reviewId.toString()
        ];
    },
    delete: function(reviewId) {
        return [
            P,
            "delete",
            reviewId.toString()
        ];
    }
};
var queryKeys = {
    get: function(courseId) {
        return [
            P,
            courseId.toString()
        ];
    }
};
var fetchCourseReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(courseId) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api__WEBPACK_IMPORTED_MODULE_1__/* .authFetch */ .SH(_api__WEBPACK_IMPORTED_MODULE_1__/* .courseReviewsUrl */ .aU(courseId))
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) {
                        throw Error("Nepodarilo sa nač\xedtať kurzov\xe9 hodnotenia");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchCourseReviews(courseId) {
        return _ref.apply(this, arguments);
    };
}();
var addCourseReview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(addRequest) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api__WEBPACK_IMPORTED_MODULE_1__/* .authPost */ .yP(_api__WEBPACK_IMPORTED_MODULE_1__/* .addCourseReviewUrl */ .KN(), addRequest)
                    ];
                case 1:
                    result = _state.sent();
                    if (!result.ok) {
                        throw Error("Nepodarilo sa pridať hodnotenie kurzu");
                    }
                    return [
                        4,
                        result.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function addCourseReview(addRequest) {
        return _ref.apply(this, arguments);
    };
}();
var editCourseReview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(reviewId, courseReviewEditRequest) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api__WEBPACK_IMPORTED_MODULE_1__/* .authPut */ .Vo(_api__WEBPACK_IMPORTED_MODULE_1__/* .courseReviewUrl */ ._2(reviewId), courseReviewEditRequest)
                    ];
                case 1:
                    result = _state.sent();
                    if (!result.ok) {
                        throw Error("Nepodarilo sa zmeniť hodnotenie kurzu");
                    }
                    return [
                        4,
                        result.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function editCourseReview(reviewId, courseReviewEditRequest) {
        return _ref.apply(this, arguments);
    };
}();
var deleteCourseReview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(reviewId) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api__WEBPACK_IMPORTED_MODULE_1__/* .authDelete */ .xV(_api__WEBPACK_IMPORTED_MODULE_1__/* .courseReviewUrl */ ._2(reviewId))
                    ];
                case 1:
                    result = _state.sent();
                    if (!result.ok) {
                        throw Error("Nepodarilo sa vymazať hodnotenie kurzu");
                    }
                    return [
                        4,
                        result.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function deleteCourseReview(reviewId) {
        return _ref.apply(this, arguments);
    };
}();
var useGetCourseReviews = function(courseId) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKeys.get(courseId), function() {
        return fetchCourseReviews(courseId);
    });
};
var useAddCourseReview = function(courseId, courseSlug) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(mutationKeys.add, function(courseReview) {
        return addCourseReview(courseReview);
    }, {
        onSuccess: function() {
            return Promise.all([
                queryKeys.get(courseId),
                _courses__WEBPACK_IMPORTED_MODULE_4__/* .queryKeys.getCourses */ .a.getCourses,
                _courseReviewOverviews__WEBPACK_IMPORTED_MODULE_3__/* .queryKeys.get */ .a.get(courseId),
                _courseOverview__WEBPACK_IMPORTED_MODULE_5__/* .queryKeys.get */ .a.get(courseSlug), 
            ].map(function(key) {
                return _queryClient__WEBPACK_IMPORTED_MODULE_2__/* ["default"].invalidateQueries */ .Z.invalidateQueries(key);
            }));
        }
    });
};
var useEditCourseReview = function(reviewId, courseId, courseSlug) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(mutationKeys.edit(reviewId), function(param) {
        var courseReviewEditRequest = param.courseReviewEditRequest;
        return editCourseReview(reviewId, courseReviewEditRequest);
    }, {
        onSuccess: function() {
            return Promise.all([
                queryKeys.get(courseId),
                _courses__WEBPACK_IMPORTED_MODULE_4__/* .queryKeys.getCourses */ .a.getCourses,
                _courseReviewOverviews__WEBPACK_IMPORTED_MODULE_3__/* .queryKeys.get */ .a.get(courseId),
                _courseOverview__WEBPACK_IMPORTED_MODULE_5__/* .queryKeys.get */ .a.get(courseSlug), 
            ].map(function(key) {
                return _queryClient__WEBPACK_IMPORTED_MODULE_2__/* ["default"].invalidateQueries */ .Z.invalidateQueries(key);
            }));
        }
    });
};
var useDeleteCourseReview = function(reviewId, courseId, courseSlug) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(mutationKeys.delete(reviewId), function() {
        return deleteCourseReview(reviewId);
    }, {
        onSuccess: function() {
            return Promise.all([
                queryKeys.get(courseId),
                _courses__WEBPACK_IMPORTED_MODULE_4__/* .queryKeys.getCourses */ .a.getCourses,
                _courseReviewOverviews__WEBPACK_IMPORTED_MODULE_3__/* .queryKeys.get */ .a.get(courseId),
                _courseOverview__WEBPACK_IMPORTED_MODULE_5__/* .queryKeys.get */ .a.get(courseSlug), 
            ].map(function(key) {
                return _queryClient__WEBPACK_IMPORTED_MODULE_2__/* ["default"].invalidateQueries */ .Z.invalidateQueries(key);
            }));
        }
    });
};


/***/ }),

/***/ 44539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ queryKeys; },
/* harmony export */   "x": function() { return /* binding */ useGetCourses; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52621);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97478);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99167);




var P = "courses";
var queryKeys = {
    getCourses: [
        P,
        "getCourses"
    ]
};
var fetchCourses = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api__WEBPACK_IMPORTED_MODULE_1__/* .authFetch */ .SH(_api__WEBPACK_IMPORTED_MODULE_1__/* .coursesOverviewUrl */ .mX())
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) {
                        throw Error("Nepodarilo sa nač\xedtať kurzy");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetchCourses() {
        return _ref.apply(this, arguments);
    };
}();
var useGetCourses = function(enabled) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKeys.getCourses, function() {
        return fetchCourses();
    }, {
        enabled: enabled
    });
};


/***/ }),

/***/ 26221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1887);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39321);




var Head = function(param) {
    var title = param.title, description = param.description, url = param.url, imageUrl = param.imageUrl, imageAlt = param.imageAlt, noIndex = param.noIndex;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:site_name",
                content: "Street of Code"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "twitter:site",
                content: "@StreetofCode1"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:locale",
                content: "sk_SK"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:image",
                content: imageUrl || _constants__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_LOGO_IMAGE_URL */ .PX
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                property: "og:image:alt",
                content: imageAlt || title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "google-site-verification",
                content: "FB24EUCOSSYhz39LdPTSNW4Yebc0El71AV7luRQcQQc"
            }),
            noIndex && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
                name: "robots",
                content: "noindex"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Head);


/***/ }),

/***/ 41246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25925);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81990);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40592);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  align-self: center;\n  padding: 50px 32px 100px 32px;\n  width: clamp(320px, 100%, 1200px);\n\n  @media ",
        " {\n    max-width: 900px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PageContentWrapper = function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: className
    }, props), {
        children: children
    }));
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db8ecefa-0"
})(_templateObject(), _theme_device__WEBPACK_IMPORTED_MODULE_2__/* .device.L */ .U.L);
/* harmony default export */ __webpack_exports__["Z"] = (PageContentWrapper);


/***/ }),

/***/ 10401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ CourseReviewContainer; },
  "Z": function() { return /* binding */ course_review_CourseReviewItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(51224);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(18473);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(70638);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(15714);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(81990);
// EXTERNAL MODULE: ./src/hooks/useEditItemActions.tsx + 1 modules
var useEditItemActions = __webpack_require__(22633);
// EXTERNAL MODULE: ./src/components/core/Flex.tsx
var Flex = __webpack_require__(90656);
// EXTERNAL MODULE: ./src/components/core/Text.tsx
var Text = __webpack_require__(43195);
// EXTERNAL MODULE: ./src/components/core/Rating.tsx
var Rating = __webpack_require__(97266);
// EXTERNAL MODULE: ./src/api/courseReviews.ts
var courseReviews = __webpack_require__(78693);
// EXTERNAL MODULE: ./src/components/domain/course-review/EditableCourseReview.tsx
var EditableCourseReview = __webpack_require__(79228);
;// CONCATENATED MODULE: ./src/components/domain/course-review/EditCourseReview.tsx






var EditCourseReview = function(param) {
    var courseSlug = param.courseSlug, review = param.review, onCancelled = param.onCancelled, onEdited = param.onEdited;
    var editCourseReviewMutation = (0,courseReviews/* useEditCourseReview */.hp)(review.id, review.courseId, courseSlug);
    var onEdit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(rating, text) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            editCourseReviewMutation.mutateAsync({
                                courseReviewEditRequest: {
                                    rating: rating,
                                    text: text
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        onEdited();
                        return [
                            2
                        ];
                }
            });
        });
        return function onEdit(rating, text) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditableCourseReview/* default */.Z, {
        initialRating: review.rating,
        initialText: review.text,
        onEditCancelled: onCancelled,
        onSubmit: onEdit
    });
};
/* harmony default export */ var course_review_EditCourseReview = (EditCourseReview);

// EXTERNAL MODULE: ./src/AuthUserContext.tsx
var AuthUserContext = __webpack_require__(92232);
// EXTERNAL MODULE: ./src/components/domain/user/UserAvatar.tsx
var UserAvatar = __webpack_require__(99990);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(9507);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(11913);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(37255);
;// CONCATENATED MODULE: ./src/components/domain/course-review/CourseReviewItem.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: stretch;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid var(--color-accent);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var CourseReviewItem = function(param) {
    var className = param.className, review = param.review, courseSlug = param.courseSlug, allowUpdating = param.allowUpdating;
    var ref = (0,AuthUserContext/* useAuth */.a)(), userId = ref.userId, isLoading = ref.isLoading;
    var deleteCourseReviewMutation = (0,courseReviews/* useDeleteCourseReview */.yE)(review.id, review.courseId, courseSlug);
    var onDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deleteCourseReviewMutation.mutateAsync()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    var isUpdatingAllowed = allowUpdating && review.userId === userId;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useEditItemActions/* default */.Z)({
        deleteAction: onDelete,
        dialogTitle: "Zmazať hodnotenie?",
        disabled: !isUpdatingAllowed
    }), 4), isEditing = ref1[0], onEdited = ref1[1], onEditCancelled = ref1[2], EditItemActions = ref1[3];
    if (isLoading) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading/* default */.Z, {});
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseReviewContainer, {
        className: className,
        review: review,
        courseSlug: courseSlug,
        isEditing: isEditing,
        onEdited: onEdited,
        onEditCancelled: onEditCancelled,
        EditItemActions: EditItemActions
    });
};
var CourseReviewContainer = function(param) {
    var className = param.className, review = param.review, courseSlug = param.courseSlug, isEditing = param.isEditing, onEdited = param.onEdited, onEditCancelled = param.onEditCancelled, EditItemActions = param.EditItemActions;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ReviewItem, {
        className: className,
        children: [
            !isEditing && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewField, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                    direction: "column",
                    alignItems: "flex-start",
                    gap: "8px",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                            justifyContent: "space-between",
                            alignSelf: "stretch",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Rating/* default */.Z, {
                                    readOnly: true,
                                    value: review.rating
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
                                    gap: "16px",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                                        direction: "row",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                                title: review.userName,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserAvatar/* default */.Z, {
                                                        src: review.imageUrl || review.staticImage,
                                                        name: review.userName,
                                                        sizePx: 32
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditItemActions, {})
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                            children: review.text
                        })
                    ]
                })
            }),
            isEditing && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(course_review_EditCourseReview, {
                review: review,
                onCancelled: onEditCancelled,
                onEdited: onEdited,
                courseSlug: courseSlug
            })
        ]
    });
};
var ReviewItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f266a41f-0"
})(_templateObject());
var ReviewField = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f266a41f-1"
})(_templateObject1());
/* harmony default export */ var course_review_CourseReviewItem = (CourseReviewItem);


/***/ }),

/***/ 79228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52621);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81990);
/* harmony import */ var _core_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21523);
/* harmony import */ var _core_Flex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90656);
/* harmony import */ var _core_Rating__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97266);
/* harmony import */ var _core_TextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3190);
/* harmony import */ var _core_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43195);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9507);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var EditableCourseReview = function(param) {
    var initialRating = param.initialRating, initialText = param.initialText, onEditCancelled = param.onEditCancelled, onSubmit = param.onSubmit;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialRating || 5), rating = ref[0], setRating = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialText || ""), text = ref1[0], setText = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var onRatingChanged = function(e, value) {
        setRating(value !== null && value !== void 0 ? value : 0);
    };
    var onTextChanged = function(e) {
        setText(e.target.value);
    };
    var handleOnSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        return [
                            4,
                            onSubmit(rating, text)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(WrapperFlex, {
        direction: "column",
        alignItems: "flex-start",
        alignSelf: "stretch",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_core_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                text: text,
                onTextChanged: onTextChanged,
                maxLength: 1500,
                label: "Sem nap\xedš svoje hodnotenie",
                itemBefore: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(RatingWrapperFlex, {
                    gap: "12px",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_core_Rating__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            name: "half-rating-read",
                            value: rating,
                            onChange: onRatingChanged
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(_core_Text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            size: "small",
                            children: [
                                rating,
                                " / 5"
                            ]
                        })
                    ]
                })
            }),
            isLoading && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_Loading__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            !isLoading && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(_core_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                alignItems: "flex-end",
                gap: "12px",
                alignSelf: "flex-start",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(SubmitButton, {
                        variant: "accent",
                        onClick: handleOnSubmit,
                        children: [
                            initialText && "Upraviť hodnotenie",
                            !initialText && "Pridať hodnotenie"
                        ]
                    }),
                    onEditCancelled && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_core_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: onEditCancelled,
                        children: "Zrušiť"
                    })
                ]
            })
        ]
    });
};
var WrapperFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_core_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a16e2e2-0"
})(_templateObject());
var SubmitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_core_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a16e2e2-1"
})(_templateObject1());
var RatingWrapperFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_core_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-6a16e2e2-2"
})(_templateObject2());
/* harmony default export */ __webpack_exports__["Z"] = (EditableCourseReview);


/***/ }),

/***/ 22633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useEditItemActions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(70638);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(15714);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(72444);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(81990);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(21967);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slide/Slide.js
var Slide = __webpack_require__(58358);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(18567);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(89180);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContentText/DialogContentText.js + 1 modules
var DialogContentText = __webpack_require__(64297);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(47771);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(11722);
// EXTERNAL MODULE: ./src/components/core/Button.tsx
var Button = __webpack_require__(21523);
// EXTERNAL MODULE: ./src/components/core/Heading.tsx
var Heading = __webpack_require__(96169);
// EXTERNAL MODULE: ./src/components/core/Text.tsx
var Text = __webpack_require__(43195);
;// CONCATENATED MODULE: ./src/components/ConfirmActionDialog.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .MuiPaper-rounded {\n    border-radius: 12px;\n  }\n\n  .MuiDialogActions-root {\n    padding: 12px;\n    padding-top: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--color-primary);\n  min-width: 300px;\n  min-height: 100px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--color-primary);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var ConfirmActionDialog = function(param) {
    var title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, primaryButtonText = param.primaryButtonText, _secondaryButtonText = param.secondaryButtonText, secondaryButtonText = _secondaryButtonText === void 0 ? "Zrušiť" : _secondaryButtonText, isOpen = param.isOpen, onClose = param.onClose, onPrimaryButtonClick = param.onPrimaryButtonClick, onSecondaryButtonClick = param.onSecondaryButtonClick;
    var Transition = /*#__PURE__*/ react.forwardRef(function(props, ref) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Slide/* default */.Z, (0,_object_spread/* default */.Z)({
            direction: "up",
            ref: ref
        }, props));
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledDialog, {
        open: isOpen,
        onClose: onClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        TransitionComponent: Transition,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DialogContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DialogTitle/* default */.Z, {
                        id: "alert-dialog-title",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
                            variant: "h5",
                            children: title
                        })
                    }),
                    description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DialogContent/* default */.Z, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DialogContentText/* default */.Z, {
                            id: "alert-dialog-description",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                                children: description
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DialogActionsWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                        onClick: onSecondaryButtonClick,
                        children: secondaryButtonText
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                        onClick: onPrimaryButtonClick,
                        variant: "danger",
                        children: primaryButtonText
                    })
                ]
            })
        ]
    });
};
var StyledDialog = (0,styled_components_browser_esm/* default */.ZP)(Dialog/* default */.Z).withConfig({
    componentId: "sc-c4b82f31-0"
})(_templateObject());
var DialogContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4b82f31-1"
})(_templateObject1());
var DialogActionsWrapper = (0,styled_components_browser_esm/* default */.ZP)(DialogActions/* default */.Z).withConfig({
    componentId: "sc-c4b82f31-2"
})(_templateObject2());
/* harmony default export */ var components_ConfirmActionDialog = (ConfirmActionDialog);

// EXTERNAL MODULE: ./src/components/core/Flex.tsx
var Flex = __webpack_require__(90656);
;// CONCATENATED MODULE: ./src/hooks/useEditItemActions.tsx

function useEditItemActions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n"
    ]);
    useEditItemActions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function useEditItemActions_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-accent);\n  width: 20px;\n  height: 20px;\n\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    useEditItemActions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function useEditItemActions_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    useEditItemActions_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var useEditItemActions = function(param) {
    var deleteAction = param.deleteAction, dialogTitle = param.dialogTitle, disabled = param.disabled;
    var ref = (0,react.useState)(false), isEditing = ref[0], setIsEditing = ref[1];
    var ref1 = (0,react.useState)(false), isConfirmingDelete = ref1[0], setIsConfirmingDelete = ref1[1];
    var onDelete = function() {
        deleteAction();
        setIsConfirmingDelete(false);
    };
    var onDeleteButtonClicked = function() {
        setIsConfirmingDelete(true);
    };
    var handleConfirmDeleteDialogClose = function() {
        setIsConfirmingDelete(false);
    };
    var onEditToggle = function() {
        setIsEditing(true);
    };
    var onEdited = function() {
        setIsEditing(false);
    };
    var onEditCancelled = function() {
        setIsEditing(false);
    };
    var EditItemActions = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
            disabled: disabled || isEditing,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                    gap: "8px",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledEditIcon, {
                            onClick: onEditToggle
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDeleteIcon, {
                            onClick: onDeleteButtonClicked
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ConfirmActionDialog, {
                    title: dialogTitle,
                    primaryButtonText: "Zmazať",
                    isOpen: isConfirmingDelete,
                    onClose: handleConfirmDeleteDialogClose,
                    onSecondaryButtonClick: handleConfirmDeleteDialogClose,
                    onPrimaryButtonClick: onDelete
                })
            ]
        });
    };
    return [
        isEditing,
        onEdited,
        onEditCancelled,
        EditItemActions
    ];
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-99bdf029-0"
})(useEditItemActions_templateObject(), function(props) {
    return props.disabled && "none";
});
var IconStyle = (0,styled_components_browser_esm/* css */.iv)(useEditItemActions_templateObject1());
var StyledEditIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* AiOutlineEdit */.$iz).withConfig({
    componentId: "sc-99bdf029-1"
})(useEditItemActions_templateObject2(), IconStyle);
var StyledDeleteIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* AiOutlineDelete */.VPh).withConfig({
    componentId: "sc-99bdf029-2"
})(_templateObject3(), IconStyle);
/* harmony default export */ var hooks_useEditItemActions = (useEditItemActions);


/***/ })

}]);